<template>
    <div class="bot">
        <div class="bot-content">
            <div style="margin-top: 16px;" v-if="isShowStep" class="step">
                <ComSteps :bfStateName="bfStateName" :completeSelection="completeSelection"></ComSteps>
            </div>
            <div class="icon-text-head">
                <InfoTit>基础信息</InfoTit>
            </div>
            <div class="basic-info">

                <div class="left">
                    <a-row>
                        <a-col :span="8">
                            <div class="le">报考类别：</div>{{ detail?.baseInfo?.applicationCategory }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">学号：</div>{{ detail.baseInfo && detail.baseInfo.studentId }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">毕业院校：</div>{{ detail.baseInfo && detail.baseInfo.graduationInstitution }}
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="8">
                            <div class="le">用人单位：</div>{{ detail.baseInfo && detail.baseInfo.orgName }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">申报岗位：</div>{{ detail.baseInfo && detail.baseInfo.postName }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">岗位编码：</div>{{ detail.baseInfo && detail.baseInfo.postNum }}
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="8">
                            <div class="le">是否服从调剂：</div>{{ detail.baseInfo && detail.baseInfo.obeyAdjustment }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">人员姓名：</div>{{ detail.baseInfo && detail.baseInfo.userName }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">健康状况：</div>{{ detail.baseInfo && detail.baseInfo.health }}
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="8">
                            <div class="le">婚姻状况：</div>{{ detail.baseInfo && detail.baseInfo.marry }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">证件类型：</div>{{ detail.baseInfo && detail.baseInfo.certificateType }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">证件号码：</div>{{ detail.baseInfo && detail.baseInfo.certificateNum }}
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="8">
                            <div class="le">通讯地址：</div>{{ detail.baseInfo && detail.baseInfo.mailAddress }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">院校所在地：</div>{{ detail.baseInfo && detail.baseInfo.graduationAddress }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">手机：</div>{{ detail.baseInfo && detail.baseInfo.mobilePhone }}
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="8">
                            <div class="le">邮箱：</div>{{ detail.baseInfo && detail.baseInfo.email }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">岗位申报时间：</div>{{ detail.baseInfo && detail.baseInfo.creatTime }}
                        </a-col>
                        <a-col :span="8">
                            <div class="le">籍贯：</div>{{ detail.baseInfo && detail.baseInfo.nativePlace }}
                        </a-col>
                    </a-row>
                </div>
                <div class="right">
                    <img v-if="detail?.baseInfo?.personHead[0]?.url" class="img"
                        :src="path + detail?.baseInfo?.personHead[0]?.url" alt="">
                    <img v-if="!detail?.baseInfo?.personHead[0]?.url" class="img" alt="">
                </div>
            </div>
            <div class="icon-text-head">
                <InfoTit>审核信息</InfoTit>
            </div>

            <div class="examine-info">
                <ComTableList :rowKey="(record, index) => record.limit + index" :pagination="false"
                    style="width: 1100px;" bordered :columns="columns" :data-source="data">
                    <span slot="isPass" slot-scope="text">
                        <a-select v-if="isEdit" v-model="text.isPass" style="width: 82px"
                            @change="handleChangeisPass($event, text)">
                            <a-select-option :value="1">
                                通过
                            </a-select-option>
                            <a-select-option :value="2">
                                不通过
                            </a-select-option>
                        </a-select>
                        <div v-if="!isEdit && 1 === text.isPass" class="only-read">
                            通过
                        </div>
                        <div v-if="!isEdit && 2 === text.isPass" class="only-read only-read-red ">
                            不通过
                        </div>
                    </span>
                    <span slot="basic" slot-scope="text">
                        <div v-html="text.basic">
                        </div>
                    </span>
                </ComTableList>
            </div>
            <div class="icon-text-head">
                <InfoTit>相关资料</InfoTit>
            </div>
            <div class="about-data">
                <div class="le">相关材料：</div>
                <ComFileList class="file-list" :list='fileList' isDownload></ComFileList>
            </div>
            <div class="about-data">
                <div class="le">报名表：</div>
                <ComFileList class="file-list" :list='applicationFormAttFileList' isDownload></ComFileList>
            </div>
            <div class="about-data">
                <div class="le">体检报告：</div>
                <ComFileList class="file-list" :list='checkupRecordFileList' isDownload></ComFileList>
            </div>
            <div class="icon-text-head">
                <InfoTit>学历学位专业要求</InfoTit>
                <div class="chose">
                    <a-select v-if="isEdit" v-model="detail.talentDiff.majorResult" style="width: 82px"
                        @change="handleChange">
                        <a-select-option :value="1">
                            通过
                        </a-select-option>
                        <a-select-option :value="2">
                            不通过
                        </a-select-option>
                    </a-select>

                    <div v-if="!isEdit && 1 === detail.talentDiff.majorResult" class="only-read">
                        通过
                    </div>
                    <div v-if="!isEdit && 2 === detail.talentDiff.majorResult" class="only-read only-read-red ">
                        不通过
                    </div>
                </div>
            </div>
            <div class="knowledge-require">
                <div class="le-text">
                    <div class="le">专业要求：</div>
                    <div v-html="checkoutHtml(detail?.learnCapacityLimt?.postLimitDate?.professional)"></div>
                </div>
            </div>
            <div class="icon-text-head">
                <InfoTit>学习经历</InfoTit>
                <div @click="openFn(5)" class="icon pointer" :class="{ 'icon-rotate': open.has(5) }">
                    <img class="img" src="@/assets/images/icon_Line_Down.png" alt="">
                </div>
            </div>
            <ComTableList :rowKey="(record, idx) => record.id + idx" :pagination="false"
                style="width:1100px;margin:0 auto;" bordered :columns="columnsDegree" :data-source="dataDegree">
                <span slot="startEndTime" slot-scope="text">
                    <span v-if="text?.startTime?.substr(0, 7)"> {{ text?.startTime?.substr(0, 7).replaceAll('-', '年') +
                        '月'
                    }}-{{ text?.endTime?.substr(0, 7).replaceAll('-', '年') + '月' }} </span>
                </span>
            </ComTableList>
            <div class="icon-text-head">
                <InfoTit>博士后（科研）经历</InfoTit>
                <div @click="openFn(0)" class="icon pointer" :class="{ 'icon-rotate': open.has(0) }">
                    <img class="img" src="@/assets/images/icon_Line_Down.png" alt="">
                </div>
            </div>
            <ComTableList :rowKey="(record, idx) => record.id + idx" :pagination="false"
                style="width:1100px;margin:0 auto;" bordered :columns="columnsResearch" :data-source="dataResearch">
                <span slot="startEndTime" slot-scope="text">
                    <span v-if="text?.startTime?.substr(0, 7)"> {{ text?.startTime?.substr(0, 7).replaceAll('-', '年') +
                        '月'
                    }}-{{ text?.endTime?.substr(0, 7).replaceAll('-', '年') + '月' }} </span>
                </span>
            </ComTableList>
            <div v-if="detail?.professionalCredential" class="knowledge-require"
                style="display: flex;justify-content: space-between;width:95%">
                <div class="le-text" style="width: auto;">
                    <div class="le">专业技术资格：</div>
                    <div>{{ detail?.professionalCredential }}</div>
                </div>
                <div class="le-text" style="width: auto;">
                    <div class="le">获得时间：</div>
                    <div>{{ detail?.professionalCredentialTime?.substr(0, 10) }}</div>
                </div>
            </div>
            <div class="icon-text-head">
                <!-- <InfoTit>个人简历</InfoTit> -->
                <InfoTit>工作经历</InfoTit>
                <div @click="openFn(1)" class="icon pointer" :class="{ 'icon-rotate': open.has(1) }">
                    <img class="img" src="@/assets/images/icon_Line_Down.png" alt="">
                </div>
            </div>
            <ComTableList :rowKey="(record) => record.id" v-if="open.has(1)" :pagination="false"
                style="width: 1100px;margin:0 auto;" bordered :columns="columnsWork" :data-source="dataWork">
                <span slot="startEndTime" slot-scope="text">
                    <span v-if="text?.startTime?.substr(0, 7)"> {{ text?.startTime?.substr(0, 7).replaceAll('-', '年') +
                        '月'
                    }}-{{ text?.endTime?.substr(0, 7).replaceAll('-', '年') + '月' }} </span>
                    <!-- {{ '2000-07-28'.substr(0,7).replaceAll('-','年')+'月' }}-{{ text?.endTime }}  -->
                </span>
            </ComTableList>
            <div class="icon-text-head">
                <InfoTit>奖惩情况</InfoTit>

                <div @click="openFn(2)" class="icon pointer" :class="{ 'icon-rotate': open.has(2) }">
                    <img class="img" src="@/assets/images/icon_Line_Down.png" alt="">
                </div>

            </div>
            <div v-if="open.has(2)">
                <div class="knowledge-require">
                    <div class="le-text" v-html="checkoutHtml(detail.rewardsPunishments)"></div>
                </div>
            </div>
            <div class="icon-text-head">
                <InfoTit>学业（科研）情况</InfoTit>
                <div @click="openFn(3)" class="icon pointer" :class="{ 'icon-rotate': open.has(3) }">
                    <img class="img" src="@/assets/images/icon_Line_Down.png" alt="">
                </div>
            </div>
            <div v-if="open.has(3)">
                <div class="knowledge-require">
                    <div class="le-text" v-html="checkoutHtml(detail.academicSituation)"></div>
                </div>
            </div>
            <div class="icon-text-head">
                <InfoTit>家庭主要成员及主要社会关系</InfoTit>

                <div @click="openFn(4)" :class="{ 'icon-rotate': open.has(4) }" class="icon pointer">
                    <img class="img" src="@/assets/images/icon_Line_Down.png" alt="">
                </div>
            </div>
            <ComTableList :rowKey="(record) => record.id" v-if="open.has(4)" :pagination="false"
                style="width: 1100px;margin:0 auto;" bordered :columns="columnsFamily" :data-source="dataFamily">
                <span slot="birthday" slot-scope="text">
                    <span v-if="text.birthday?.substr(0, 7)">{{ text.birthday?.substr(0, 7).replaceAll('-', '年') + '月'
                        }}</span>
                </span>
            </ComTableList>
            <div class="icon-text-head">
                <InfoTit>审核意见</InfoTit>
            </div>
            <div class='appeal-info'>
                <template v-for="(item, index) in selectApplyInforma">
                    <ul v-if="item.auditResult != -1" :key="index">
                        <!-- <ul> -->
                        <li><span class="name">{{ item.title }}：</span><span class="content">
                                {{ item.opinionContent }}
                            </span></li>
                        <li v-if="item.attachment" class="file-flex"><span class="name">处理附件：</span>
                            <ComFileList class="file-list" :list="JSON.parse(item.attachment)" isDownload>
                            </ComFileList>
                        </li>
                        <li v-if="$route.path.includes('institution')"><span class="name">审核时间：</span><span
                                class="content">{{
                                    item.updateTime }}</span></li>
                        <li style="display: flex; align-items: center;"><span class="name">处理结果：</span>
                            <span class="content" style="display: flex; align-items: center;">
                                <img v-if="item.auditResult == 0" src="@/assets/images/FilledCheckCircle.png" alt="">
                                <div v-if="item.auditResult == 0" style="margin-left: 5px;color:#3DB273"> {{
                                    '已通过' }}</div>
                                <img v-if="item.auditResult == 1" src="@/assets/images/FilledCloseCircle.png" alt="">
                                <div v-if="item.auditResult == 1" style="margin-left: 5px;color:#EF4444"> {{
                                    '未通过' }}</div>
                                <img v-if="item.auditResult == 2" src="@/assets/images/FilledLeftcircle.png" alt="">
                                <div v-if="item.auditResult == 2" style="margin-left: 5px;color:#F59E0B"> {{
                                    '返回修改' }}</div>
                            </span>
                        </li>
                    </ul>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ComSteps from '@/components/common/com-steps.vue';
import InfoTit from '@/components/tit/info-tit.vue';
import ComTableList from '@/components/com-table-list/index.vue';
import ComFileList from "@/components/common/com-file-list";
import { _ctxPath } from '@/api/http'
import { getAuditDetails } from '@/api/declaration'
import { selectApplyInforma } from '@/api/userInfo'
export default {
    name: 'XiamenTalentUiIndex',
    components: {
        InfoTit,
        ComTableList,
        ComFileList,
        ComSteps
    },
    // isEd是否可修改，isShowStep是否显示步骤条,current步骤条第几步，status步骤条状态
    // props: ['id','isEdit', 'isShowStep', 'current', 'status' ],
    props: {
        id: {
            type: String,
            required: true
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        isShowStep: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isProvincialUnit: 0,//0上一级为主管单位 ， 1上一级为市委组织部 。。。0就是非省属，1相反
            bfStateName: '',
            completeSelection: '',
            selectApplyInforma: [],
            talentDiff: {},
            detail: {
                talentDiff: {
                    "id": null,
                    "version": null,
                    "updateTime": null,
                    "createTime": null,
                    "tenantId": null,
                    "draft": null,
                    "orderNo": null,
                    "parentId": null,
                    "scientificResult": null,
                    "addressResult": null,
                    "nationResult": null,
                    "politicalOutlookResult": null,
                    "sexResult": null,
                    "degreeResult": null,
                    "educationResult": null,
                    "birthadyResult": null,
                    "majorResult": null
                }
            },
            path: _ctxPath,
            fileList: [],
            checkupRecordFileList: [],
            applicationFormAttFileList: [],
            open: new Set([1, 2, 3, 4]),
            columns: [
                {
                    title: '相关信息',
                    dataIndex: 'basic',
                    key: 'basic',
                    width: 470,
                    scopedSlots: { customRender: 'basic' },
                    ellipsis: true
                },
                {
                    title: '岗位要求',
                    dataIndex: 'limit',
                    key: 'limit',
                    width: 470,
                    ellipsis: true
                },
                {
                    title: '是否通过',
                    dataIndex: 'isPass',
                    key: 'isPass',
                    width: 158,
                    scopedSlots: { customRender: 'isPass' },
                    ellipsis: true
                },

            ],
            columnsDegree: [
                {
                    title: '学历',
                    dataIndex: 'education',
                    key: 'education',
                    width: 80,
                    ellipsis: true
                },
                {
                    title: '起止时间',
                    key: 'startEndTime',
                    width: 180,
                    scopedSlots: { customRender: 'startEndTime' },
                },
                {
                    title: '毕业院校及院系',
                    dataIndex: 'graduationSchool',
                    key: 'graduationSchool',
                    width: 260,
                    ellipsis: true
                },
                {
                    title: '专业',
                    dataIndex: 'major',
                    key: 'major',
                    width: 260,
                    ellipsis: true
                },
                {
                    title: '专业代码',
                    dataIndex: 'majorCode',
                    key: 'majorCode',
                    width: 200,
                    ellipsis: true
                },
                {
                    title: '院校所在地',
                    dataIndex: 'institutionLocation',
                    key: 'institutionLocation',
                    width: 130,
                    ellipsis: true
                },

            ],
            columnsResearch: [
                {
                    title: '类别',
                    dataIndex: 'category',
                    key: 'category',
                    width: 80,
                    ellipsis: true
                },
                {
                    title: '起止时间',
                    key: 'startEndTime',
                    width: 180,
                    scopedSlots: { customRender: 'startEndTime' },
                },
                {
                    title: '院校及院系',
                    dataIndex: 'graduationSchool',
                    key: 'graduationSchool',
                    width: 260,
                    ellipsis: true
                },
                {
                    title: '专业',
                    dataIndex: 'major',
                    key: 'major',
                    width: 260,
                    ellipsis: true
                },
                {
                    title: '专业代码',
                    dataIndex: 'majorCode',
                    key: 'majorCode',
                    width: 200,
                    ellipsis: true
                },
                {
                    title: '科研机构所在地',
                    dataIndex: 'institutionLocation',
                    key: 'institutionLocation',
                    width: 140,
                    ellipsis: true
                },

            ],
            columnsFamily: [
                {
                    title: '称谓',
                    dataIndex: 'prefixTitle',
                    key: 'prefixTitle',
                    width: 150,

                    ellipsis: true
                },
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    width: 237,
                    ellipsis: true
                },
                {
                    title: '出生年月',
                    dataIndex: 'birthday',
                    key: 'birthday',
                    width: 237,
                    ellipsis: true,
                    scopedSlots: { customRender: 'birthday' },
                },
                {
                    key: 'setPoliticalOutlookName',
                    dataIndex: 'setPoliticalOutlookName',
                    title: '政治面貌',
                    width: 237,
                    ellipsis: true,
                },
                {
                    title: '工作单位及职务',
                    dataIndex: 'workUnit',
                    key: 'workUnit',
                    width: 237,
                    ellipsis: true
                },

            ],
            columnsWork: [
                {
                    title: '序号',
                    dataIndex: 'num',
                    width: '50px',
                    // fixed: 'left',
                    customRender: (t, r, i) => `${i + 1}`,
                    align: 'center'
                },
                {
                    title: '起止时间',
                    key: 'startEndTime',
                    width: 200,
                    scopedSlots: { customRender: 'startEndTime' },
                },
                {
                    title: '工作单位',
                    dataIndex: 'workUnit',
                    key: 'workUnit',
                    width: 340,
                    ellipsis: true
                },
                {
                    title: '职务',
                    dataIndex: 'post',
                    key: 'post',
                    width: 340,
                    ellipsis: true
                },
                {
                    title: '工作所在地',
                    dataIndex: 'workLocation',
                    key: 'workLocation',
                    width: 120,
                    ellipsis: true
                },
            ],
            data: [],
            dataDegree: [],
            dataResearch: [],
            dataFamily: [],
            dataWork: []
        };
    },
    mounted() {
        this.getDetail()
    },
    watch: {
        id: {
            handler() {
                this.getDetail()
            },
        },
    },
    methods: {
        // 更改时间为年月
        // changeTimeYearMonth(time){
        //     if(time){
        //         return time?.substr(0,7).replaceAll('-','年')+'月'
        //     }else{
        //         return ''
        //     }
        // },
        checkoutHtml(str) {
            return str?.replace(/\n/g, '<br/>') || ''
        },
        // 获取详情数据
        getDetail() {
            getAuditDetails({ id: this.id }).then((res) => {
                console.log("单位申报审核详情", res.data);
                console.log(res.data);
                if (res.code == 0) {
                    this.detail = res.data;
                    // this.bfState = this.detail.bfState
                    this.completeSelection = this.detail.baseInfo?.completeSelection
                    this.bfStateName = this.detail.bfStateName
                    this.isProvincialUnit = this.detail.isProvincialUnit
                    this.getBasicList(this.detail)
                    this.dataFamily = this.detail.familyMembers
                    this.dataWork = this.detail.workExperiences
                    //学历列表过滤没有填的字段。
                    this.dataDegree = this.detail.learningExperiences;
                    this.dataResearch = this.detail.postDoctorExperiences;
                    // 渲染材料
                    this.fileList = this.detail.materialData?.attachments
                    this.checkupRecordFileList = this.detail.checkupRecord?.attachments
                    this.applicationFormAttFileList = this.detail.applicationFormAtt
                    this.talentDiff = JSON.parse(JSON.stringify(this.detail.talentDiff))
                    this.$emit('changeTalentDiff', this.talentDiff)
                    this.$emit('changeBfstate', this.bfStateName)
                    this.$emit('changeCompleteSelection', this.completeSelection)
                    this.$emit('changeAppealIds', this.detail.baseInfo.talentPostId, this.detail.baseInfo.declarerId)
                    // isAdjusted： 1 - 被调剂 0 - 未被调剂
                    // originalId：原申报数据id
                    // 如果为0 没有id 说明没有被调剂过
                    // 如果为1 没有id 说明是被调剂原数据
                    // 如果为0 有id 说明是调剂后的新数据
                    // if(res.data.baseInfo?.isAdjusted === 0 && res.data.baseInfo?.originalId){
                    this.$emit('changeoriginalId', res.data.baseInfo?.isAdjusted, res.data.baseInfo?.originalId)
                    // }

                }
            })
            selectApplyInforma({ id: this.id }).then((res) => {
                // console.log("selectApplyInforma", res);
                if (res.code == 0) {
                    this.selectApplyInforma = res.data;
                }

            })
        },
        // 转换获取基本信息列表
        getBasicList(detail) {
            this.data = []
            const key = ['birthadyResult', 'sexResult', 'addressResult', 'politicalOutlookResult', 'nationResult', 'degreeResult', 'educationResult',]
            // const basicKey = ['出生日期：', '性别：', '户籍所在地：', '加入党派：,入党年月：,政治面貌：', '民族：', '学位：', '学历：']
            const basicKey = ['出生日期：', '性别：', '户籍所在地：', ',,政治面貌：', '民族：', '学位：', '学历：']
            const limitKey = ['最高年龄：', '性别要求：', '户籍要求：', '政治面貌要求：', '民族要求：', '最低学历学位要求：', '最低学历要求：']
            key.forEach((element, index) => {
                if (!detail.delarationInfo.personList[index] || detail.delarationInfo.personList[index] == 'null' || detail.delarationInfo.personList[index] == null) {
                    detail.delarationInfo.personList[index] = ''
                }
                if (!detail.delarationInfo.limitList[index] || detail.delarationInfo.limitList[index] == 'null' || detail.delarationInfo.limitList[index] == null) {
                    detail.delarationInfo.limitList[index] = ''
                }
                if (index == 3) {
                    // 处理政治面貌
                    let threeStr = ''
                    let arr = detail.delarationInfo.personList[index].split(',')
                    arr.forEach((item, index) => {
                        if (item == 'null') {
                            arr[index] = ''
                        }
                    })
                    basicKey[index].split(',').map((element, index) => {
                        console.log(element);
                        // threeStr += (element + arr[index] + '<br>')
                        if (index == 2) {
                            threeStr = element + arr[index]
                        }
                        // threeStr += (element + arr[index])
                    })
                    this.data.push({
                        id: index,
                        basic: threeStr,
                        limit: limitKey[index] + detail.delarationInfo.limitList[index],
                        isPass: detail.talentDiff[element],
                    })
                } else if (index === 0 || index === 6) {

                    this.data.push({
                        key: index,
                        basic: basicKey[index] + detail.delarationInfo.personList[index],
                        limit: limitKey[index] + detail.delarationInfo.limitList[index],
                        isPass: detail.talentDiff[element],
                    })
                }

            });
            // console.log(this.data);
        },
        openFn(num) {
            if (this.open.has(num)) {
                this.open.delete(num)
            } else {
                this.open.add(num)
            }
            this.$forceUpdate();
        },
        subEvent() {
            // console.log(11);
        },
        handleChangeisPass(e, text) {
            e
            // console.log(e, text);
            this.data.forEach((element, index) => {
                if (element.key == text.key) {
                    this.data[index] = text
                }
            });
            ['birthadyResult', 'sexResult', 'addressResult', 'politicalOutlookResult', 'nationResult', 'degreeResult', 'educationResult',]
            this.talentDiff.birthadyResult = this.data[0].isPass
            // this.talentDiff.sexResult = this.data[1].isPass
            // this.talentDiff.addressResult = this.data[2].isPass
            this.talentDiff.politicalOutlookResult = this.data[1].isPass
            // this.talentDiff.nationResult = this.data[4].isPass
            // this.talentDiff.degreeResult = this.data[5].isPass
            this.talentDiff.educationResult = this.data[2].isPass
            this.$emit('changeTalentDiff', this.talentDiff)
            // console.log(this.talentDiff, 'this.detail.talentDiff');
            this.$forceUpdate();
            console.log(this.data, 'data');

        },
        handleChange() {
            this.talentDiff.majorResult = this.detail.talentDiff.majorResult
            this.talentDiff.scientificResult = this.detail.talentDiff.scientificResult
            this.$emit('changeTalentDiff', this.talentDiff)
            // console.log(this.detail.talentDiff, 'this.detail.talentDiff');
        },
        // 审批状态
        declareStatus(key) {
            if (key == 0) {
                return '未处理'
            } else if (key == 1) {
                return '通过'
            } else if (key == 2) {
                return '不通过'
            } else if (key == 3) {
                return '受理'
            } else if (key == 4) {
                return '暂存'
            }
        },


    },
};
</script>
<style lang="less" scoped>
.bot-content {
    width: 97%;

    .step {
        width: 1100px;
        height: 48px;
        margin: 0 auto;
    }

    .icon-text-head {
        width: 1096px;
        height: 48px;
        margin: 0 auto;
        opacity: 1;
        position: relative;

        .img {
            width: 20px;
            height: 12px;
            opacity: 1;
        }

        .chose {
            width: 82px;
            height: 38px;
            position: absolute;
            top: 0;
            right: 20px;
            display: flex;
            align-items: center;
        }

        .icon {
            width: 12px;
            height: 12px;
            opacity: 1;
            border: 0 solid #979797;
            position: absolute;
            top: 20px;
            right: 20px;
        }


    }

    .basic-info {
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        font-family: "PingFang SC";
        display: flex;

        .left {
            width: 73%;
            margin-left: 38px;
            color: #111111;
            margin-top: 12px;

            .le {
                display: inline-block;
                color: #505d6e;
                text-align: left;
                height: 35px;
            }
        }

        .right {
            margin-top: 10px;
            width: 25%;

            .img {
                width: 110px;
                height: 155px;
                opacity: 1;

            }

        }
    }

    .examine-info {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }

    .about-data {
        width: 1096px;
        margin: 0 auto;
        display: flex;
        margin-left: 38px;

        .le {
            height: 22px;
            color: #111111;
            font-size: 14px;
            font-weight: 400;
            font-family: "PingFang SC";
            text-align: left;
            line-height: 22px;
            flex-shrink: 0;
        }
    }

    .knowledge-require {
        width: 100%;
        margin-left: 38px;

        .le-text {
            color: #111111;
            display: flex;
            width: 95%;
            font-size: 14px;
            font-weight: 400;
            font-family: "PingFang SC";
            text-align: left;
            line-height: 22px;
            margin-bottom: 10px;
            margin-top: 5px;

            .le {
                color: #505d6e;
                flex-shrink: 0;
            }
        }
    }
}


.only-read {
    width: 76px;
    height: 22px;
    border-radius: 4px;
    opacity: 1;
    border: 1px solid #9edea6;
    background: #e9f7e9;
    color: #28b84a;
    font-size: 12px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: center;
    line-height: 22px;
}

.only-read-red {
    border: 1px solid #ffc8c2;
    background: #fff2f0;
    color: #ef4444;
}

.file-flex {
    display: flex;
    justify-content: flex-start;

    .name {
        flex: 0 0 70px;
    }

    .file-list {
        flex: 1 0 1022px;
    }
}

::v-deep {
    .ant-steps-item {
        flex: auto;
        padding-right: 20px;

        &:last-child {
            padding-right: 0px;
        }
    }

    .icon {
        transition: all;
        transition-duration: .3s;
    }

    .icon-rotate {
        transition: all;
        transition-duration: .3s;
        transform: rotate(180deg);
    }

    .appeal-info {
        ul {
            position: relative;
            margin-left: 34px;
            margin-bottom: 20px;
            padding: 12px 12px 0;
            background: #F7F8FA;
            border-radius: 5px;

            &::after {
                position: absolute;
                content: '';
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #28B84A;
                left: -15px;
                top: 20px;
            }

            &::before {
                position: absolute;
                content: '';
                width: 2px;
                height: calc(100% - 25px);
                background: #F7F7F7;
                left: -13px;
                top: 25px;
                z-index: 0;
            }

            li {
                margin-bottom: 4px;
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;

                &:last-of-type {
                    margin-bottom: 0;
                }

                .title {
                    color: #111111;
                    font-weight: 600;
                }

                .name {
                    color: #505D6E;
                }

                .content {
                    color: #111111;
                }
            }

        }
    }

    // 步骤
    .ant-steps-item-wait .ant-steps-item-icon {
        border: none;
        background-color: #F1F5F8;
        color: #7A8591
    }

    .yellowBg .ant-steps-item-process .ant-steps-item-icon {
        background-color: #F59E0B;
    }

    textarea.ant-input {
        border: 4px solid #f0f8ff;
        background: #f9fafb;
        resize: none;
    }


    .ant-table-thead>tr>th {
        background: #F1F5F9;
    }

    .ant-table-thead>tr>th,
    .ant-table-tbody>tr>td {
        padding: 12px 12px;
    }

    .ant-table-thead>tr>th {
        color: #505d6e;
        font-size: 14px;
        font-weight: 500;
        font-family: "PingFang SC";
    }

    .ant-table-tbody>tr>td {
        color: #111111;
        font-size: 14px;
        font-weight: 400;
        font-family: "PingFang SC";
    }

    .ant-select {
        color: #111111;
        font-size: 12px;
        font-weight: 400;
        font-family: "PingFang SC";
        text-align: left;

    }

    .ant-select-selection {
        background: #f1f5f8;
        border: none;
        text-align: left;
        text-indent: 0;
    }

    .ant-select-selection--single {
        height: 30px;
    }

    .ant-select-selection--single .ant-select-selection__rendered {
        margin-right: 0;
    }
}
</style>
<style scoped>
@import "@/styles/declare-check-inst.scss"
</style>
